import { useFeatureContext } from "@omni/ui/components/Product/Feature/KeyFeatures/components/feature/context/feature.context";
import { cn } from "@omni/utils/styles";

type Props = {
    className?: string;
};

export const Name = ({ className }: Props) => {
    const { feature } = useFeatureContext();

    return <span className={cn(className)}>{feature.name}</span>;
};
